export default __webpack_public_path__ + "static/media/img_shouye_tengzhou.37cf79ea.png";